import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterDeviceType } from './z-printer-device-type';
import { ZPrinterManufacturer } from './z-printer-paper-manufacturer';
import { ZPrinterPaperSize } from './z-printer-paper-size';

interface UpsertZPrinterConfigurationFields {
  id?: string;
  ip: string;
  port: number;
  name?: string;
  manufacturer?: ZPrinterManufacturer;
  device_type?: ZPrinterDeviceType;
  paper_size?: ZPrinterPaperSize;
  row_version?: number;
}

@MappedClass()
export class UpsertZPrinterConfiguration {
  @MappedProperty()
  id?: string;

  @MappedProperty()
  ip: string;

  @MappedProperty()
  port: number;

  @MappedProperty()
  name?: string;

  @MappedProperty()
  manufacturer?: ZPrinterManufacturer;

  @MappedProperty()
  device_type?: ZPrinterDeviceType;

  @MappedProperty()
  paper_size?: ZPrinterPaperSize;

  @MappedProperty()
  row_version?: number;

  constructor(fields: UpsertZPrinterConfigurationFields) {
    Object.assign(this, fields);
  }
}
